import apiClient from './apiClient'
import type { GetLanguagesResponse } from '@/types/api'

/**
 * GET /api/languages
 * Get all active languages. Used to populate the language selector.
 *
 * The body is shape-checked before it is handed to React Query: a 200 whose
 * payload is not the expected object (an SWA/App Service HTML fallback, or an
 * IdP login page returned after a transparently-followed auth redirect) would
 * otherwise be cached and dereferenced by the language selector.
 */
export async function fetchLanguages(): Promise<GetLanguagesResponse> {
  const { data } = await apiClient.get<GetLanguagesResponse>('/languages')
  if (!data || !Array.isArray(data.languages)) {
    throw new Error('GET /languages returned an unexpected payload shape')
  }
  return data
}
